'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../extends-f8003900.js');
var objectWithoutProperties = require('../../objectWithoutProperties-aa43106a.js');
var styles_breakpoints = require('../../breakpoints-7bb24b2d.js');
var React = require('react');
var index = require('../../index-0e40e0c2.js');
var utils_isType_isType = require('../../utils/isType/isType.js');
var components_NuDSProvider_NuDSProvider = require('../NuDSProvider/NuDSProvider.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var components_Typography_Typography = require('../Typography/Typography.js');
var components_Icon_Icon = require('../../Icon-b778e008.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../GlobalStyle/GlobalStyle.js');
require('styled-components');
require('../../theme-340a6118.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../defineProperty-3cad0327.js');
require('../../xstyled-prop-types.es-56667676.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var backgroundLinearGradient = function backgroundLinearGradient(color, colorVariant) {
  return xstyledStyledComponents_es.css(_templateObject$1 || (_templateObject$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  background-image:\n    linear-gradient(120deg, ", " 0%, ", " 100%),\n    linear-gradient(120deg, transparent, transparent);\n"])), styles_themeUtils.nuDSColor(color, colorVariant), styles_themeUtils.nuDSColor(color, colorVariant));
};

var underlineEffect = function underlineEffect(color, colorVariant) {
  return xstyledStyledComponents_es.css(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  background-repeat: no-repeat;\n  background-position: 0 100%, 100% 100%;\n  background-size: 0 8%, 100% 8%;\n  transition: background-size 0.2s ease-in-out;\n  ", ";\n\n  &:hover, &:focus {\n    text-decoration: none;\n    background-size: 100% 8%, 100% 8%;\n  }\n"])), backgroundLinearGradient(color, colorVariant));
};

var variantMapStyle = {
  action: xstyledStyledComponents_es.css(_templateObject3 || (_templateObject3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    line-height: 1.35;\n    display: inline-flex;\n    align-items: center;\n    ", ";\n  "])), function (_ref) {
    var color = _ref.color,
        colorVariant = _ref.colorVariant;
    return underlineEffect(color, colorVariant);
  }),
  text: xstyledStyledComponents_es.css(_templateObject4 || (_templateObject4 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    &:hover {\n      text-decoration: underline;\n    }\n    &:focus {\n      text-decoration: none;\n      outline-width: 2px;\n      outline-style: solid;\n      outline-color: ", ";\n    }\n  "])), function (_ref2) {
    var color = _ref2.color,
        colorVariant = _ref2.colorVariant;
    return styles_themeUtils.nuDSColor(color, colorVariant);
  })
};
var StyledTypography = xstyledStyledComponents_es.styled(components_Typography_Typography['default'])(_templateObject5 || (_templateObject5 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  text-decoration: none;\n\n  ", ";\n"])), function (_ref3) {
  var linkVariant = _ref3.linkVariant;
  return variantMapStyle[linkVariant] ? variantMapStyle[linkVariant] : variantMapStyle.text;
});
StyledTypography.displayName = 'StyledTypography';
var UnstyledLink = xstyledStyledComponents_es.styled.a(_templateObject6 || (_templateObject6 = xstyledStyledComponents_es.taggedTemplateLiteral([""])));
UnstyledLink.displayName = 'UnstyledLink';

var _templateObject;
var StyledIcon = xstyledStyledComponents_es.styled(components_Icon_Icon.Icon)(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  margin: 0 0 0 0.5rem;\n  min-width: 16px;\n"])));

var variantMapper = {
  text: 'subtitle1',
  action: 'subtitle1'
};
var colorMapper = {
  primary: {
    color: 'primary.default'
  },
  primaryLight: {
    color: 'primary.light'
  },
  white: {
    color: 'white.default'
  },
  black: {
    color: 'black.default'
  }
};
var linkVariantsPropType = index.PropTypes.oneOf(Object.keys(variantMapper));
var linkColorsPropType = index.PropTypes.oneOf([].concat(styles_breakpoints.toConsumableArray(Object.keys(colorMapper)), ['inherit', 'initial']));

function renderActionIcons(variant) {
  var isExternal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var canRender = variant === 'action';
  var iconName = isExternal ? 'arrow-up-right' : 'arrow-right';
  var titleName = isExternal ? 'External Link' : 'Internal Link';
  return canRender && /*#__PURE__*/React__default['default'].createElement(StyledIcon, {
    size: "small",
    title: titleName,
    name: iconName
  });
}

var GROUP_TO_PUT_SLASH = /\/?(\?|#|$)/;

function addSlashAtEnd(href) {
  return "".concat(href.replace(GROUP_TO_PUT_SLASH, '/$1'));
}

var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      variant = props.variant,
      color = props.color,
      href = props.href,
      iconProps = props.iconProps,
      intlKey = props.intlKey,
      intlValues = props.intlValues,
      rel = props.rel,
      target = props.target,
      typographyProps = props.typographyProps,
      noStyle = props.noStyle,
      rest = objectWithoutProperties.objectWithoutProperties(props, ["children", "variant", "color", "href", "iconProps", "intlKey", "intlValues", "rel", "target", "typographyProps", "noStyle"]);

  var _useContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
      formatMessage = _useContext.formatMessage,
      RouterLinkComponent = _useContext.routerLinkComponent;

  var isExternalURL = !href.startsWith('/');
  var isAnchor = href.startsWith('#');
  var normalizedHref = !isAnchor && !isExternalURL ? addSlashAtEnd(href) : href;
  var typographyVariant = variantMapper[variant];
  var typographyColor = colorMapper[color];
  var componentChildren = intlKey ? formatMessage({
    id: intlKey
  }, intlValues) : children;
  var LinkComponent = noStyle ? UnstyledLink : StyledTypography;

  var linkProps = _extends._extends({
    linkVariant: variant,
    variant: typographyVariant,
    strong: true,
    colorLink: color
  }, typographyColor);

  var attrsProps = _extends._extends({}, linkProps, typographyProps, {
    noStyle: noStyle,
    ref: ref
  });

  if (utils_isType_isType.isType('undefined', target) && isExternalURL && !isAnchor) {
    var externalProps = {
      target: '_blank',
      rel: 'noopener'
    };
    attrsProps = _extends._extends({}, externalProps, attrsProps);
  }

  if (target) {
    if (target === '_blank') {
      attrsProps = _extends._extends({}, attrsProps, {
        target: target,
        rel: 'noopener'
      });
    }

    attrsProps = _extends._extends({}, attrsProps, {
      target: target
    });
  }

  if (rel) {
    attrsProps = _extends._extends({}, attrsProps, {
      rel: rel
    });
  }

  var iconComponent = Object.keys(iconProps).length ? /*#__PURE__*/React__default['default'].createElement(StyledIcon, {
    size: iconProps.size,
    title: iconProps.title,
    name: iconProps.name
  }) : renderActionIcons(variant, isExternalURL);
  var hasRouterLink = Boolean(RouterLinkComponent);

  if (!isExternalURL && hasRouterLink) {
    return /*#__PURE__*/React__default['default'].createElement(RouterLinkComponent, _extends._extends({
      tag: "a",
      href: normalizedHref
    }, attrsProps, rest, {
      linkComponent: LinkComponent
    }), componentChildren, iconComponent);
  }

  return /*#__PURE__*/React__default['default'].createElement(LinkComponent, _extends._extends({
    tag: "a",
    href: normalizedHref
  }, attrsProps, rest), componentChildren, iconComponent);
});
Link.defaultProps = {
  children: undefined,
  className: null,
  color: 'primary',
  hrefLang: undefined,
  intlKey: null,
  intlValues: {},
  noStyle: false,
  variant: 'text',
  target: undefined,
  rel: undefined,
  typographyProps: {},
  iconProps: {}
};
Link.propTypes = {
  children: index.PropTypes.node,
  className: index.PropTypes.string,

  /** The color styles that will be rendered */
  color: linkColorsPropType,

  /** The URL that will be rendered */
  href: index.PropTypes.string.isRequired,

  /** Specifies the language of the linked document */
  hrefLang: index.PropTypes.string,

  /** An object containing the props to be passed down to the Icon component */
  iconProps: index.PropTypes.shape({
    name: index.PropTypes.string,
    size: index.PropTypes.string,
    title: index.PropTypes.string
  }),

  /** An i18n key that will be used to search for content */
  intlKey: index.PropTypes.string,

  /** An object containing the values to be passed down to the internationalized message */
  intlValues: index.PropTypes.shape({}),

  /** Specifies if the styled component should be rendered */
  noStyle: index.PropTypes.bool,

  /** Specifies the relationship between the current document and the linked document */
  rel: index.PropTypes.oneOf(['', 'alternate', 'author', 'bookmark', 'external', 'help', 'license', 'next', 'nofollow', 'noreferrer', 'noopener', 'prev', 'search', 'tag']),

  /** The target attribute specifies where to open the linked document */
  target: index.PropTypes.oneOf(['', '_blank', '_self', '_parent', '_parent', 'framename']),

  /** An object containing the props to be passed down to the Typography component */
  typographyProps: index.PropTypes.shape({
    color: index.PropTypes.string,
    colorVariant: index.PropTypes.string,
    variant: index.PropTypes.string
  }),

  /** The font style that will be rendered */
  variant: linkVariantsPropType
};
Link.displayName = 'Link';

exports.colorMapper = colorMapper;
exports.default = Link;
exports.linkColorsPropType = linkColorsPropType;
exports.linkVariantsPropType = linkVariantsPropType;
exports.variantMapper = variantMapper;
//# sourceMappingURL=Link.js.map
